import { InsertionOrderBudgetModel } from '.'
import { Creative } from '.'
import { AdvancedSettingModel } from './AdvancedSetting'

export class CampaignModel {
  constructor(data) {
    const {
      id,
      name,
      code,
      creativeType,
      creativeAttachTarget,
      creatives,
      deliveryMenu: { ownerProfileMenuId, menuType },
      enablePacingPerBudget,
      pacingType,
      dailyLimitBudget,
      evenPacePercentage,
      insertionOrderBudgets,
      useAdvancedSetting,
      advancedSetting,
      goalType,
      goalCpc,
      enableOptimization,
      transactionProgress,
      status,
      useCreativeSchedule,
    } = data

    this.id = id
    this.name = name
    this.code = code
    this.creativeType = creativeType
    this.creativeAttachTarget = creativeAttachTarget
    this.creatives = creatives.map(Creative.assign)
    // メニューリファクタの結果、menuIdをownerProfileMenuIdに置き換えた
    this.menuId = ownerProfileMenuId
    this.menuType = menuType
    this.enablePacingPerBudget = enablePacingPerBudget
    this.pacingType = pacingType
    this.dailyLimitBudget = dailyLimitBudget
    this.evenPacePercentage = evenPacePercentage
    this.insertionOrderBudgets = insertionOrderBudgets.map(
      InsertionOrderBudgetModel.assign,
    )
    this.useAdvancedSetting = useAdvancedSetting
    this.advancedSetting = new AdvancedSettingModel(advancedSetting)
    this.goalType = goalType
    this.goalCpc = goalCpc
    this.enableOptimization = enableOptimization
    this.transactionProgress = transactionProgress
    this.status = status
    this.useCreativeSchedule = useCreativeSchedule
  }

  static assign(data) {
    return new CampaignModel(data)
  }
}
